import React from 'react';
import useApiClient from '../../../Base/Hooks/useApiClient';
import apiClient from '../../../../Services/ApiClient';
import useLoading from '../../../Base/Hooks/useLoading';
import useNotification from '../../../../Hooks/useNotification.hook';
import { CSSZUser } from '../../Interfaces/CSSZ.interface';
import CSSZSickLeaveCertificateTakeoverForm, {
	CSSZTakeoverValues,
} from './CSSZSickLeaveCertificateTakeoverForm';

interface Props {
	onSubmit: () => void;
	user: CSSZUser;
}

const CSSZSickLeaveCertificateTakeover = ({ onSubmit, user }: Props) => {
	const { isLoading, setIsLoading } = useLoading();
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();

	const handleSubmit = async (values: CSSZTakeoverValues) => {
		setIsLoading(true);

		try {
			const response = await apiClient.post(
				`/user/${user.id}/sick-leave/takeover`,
				values,
			);

			if (response.status === 200 || response.status === 502) {
				onSubmit();
				showNotificationSuccess({
					content: 'component.CSSZSickLeaveCertificateTakeover.successMessage',
				});
			}
		} catch (err) {
			displayError(err);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<CSSZSickLeaveCertificateTakeoverForm
			onSubmit={handleSubmit}
			disableSubmit={isLoading}
		/>
	);
};

export default CSSZSickLeaveCertificateTakeover;
